import Tracker from "./tracker.js";

class Properties {
    constructor(modifiedKeys, allKeys, oldValues, newValues) {
        this._modifiedKeys = modifiedKeys;
        this._allKeys = allKeys;
        this._oldValues = oldValues;
        this._newValues = newValues;
    }

    *iterateModified() {
        for (const key of this._modifiedKeys) {
            yield this.get(key);
        }
    }

    *iterateAll() {
        for (const key of this._allKeys) {
            yield this.get(key);
        }
    }

    wasModified(key) {
        return this._modifiedKeys.has(key);
    }

    get(key) {
        const oldValues = this._oldValues, newValues = this._newValues;

        return {
            key,
            oldExists: oldValues.has(key),
            newExists: newValues.has(key),
            oldValue: oldValues.get(key),
            newValue: newValues.get(key),
        };
    }
}

class DictTracker extends Tracker {
    constructor(userdata) {
        super();

        this._modifiedKeys = new Set();
        this._allKeys = new Set();
        this._oldValues = new Map();
        this._newValues = new Map();

        const props = new Properties(this._modifiedKeys, this._allKeys, this._oldValues, this._newValues);

        this._trackData = Object.freeze({ props, userdata });
    }

    protected_startUpdate() {
        return this._trackData;
    }

    protected_finishUpdate() {
        for (const key of this._modifiedKeys) {
            if (this._newValues.has(key)) {
                this._oldValues.set(key, this._newValues.get(key));
            } else {
                this._oldValues.delete(key);
                this._allKeys.delete(key);
            }
        }

        this._modifiedKeys.clear();
    }

    setValue(key, newValue) {
        const changed = !(this._oldValues.has(key) && this._oldValues.get(key) === newValue);

        this._newValues.set(key, newValue);

        if (changed) {
            this._modifiedKeys.add(key);
        } else {
            this._modifiedKeys.delete(key);
        }

        this._allKeys.add(key);

        this.protected_needsUpdate(this._modifiedKeys.size !== 0);
    }

    deleteValue(key) {
        const changed = this._oldValues.has(key);

        this._newValues.delete(key);

        if (changed) {
            this._modifiedKeys.add(key);
            this._allKeys.add(key);
        } else {
            this._modifiedKeys.delete(key);
            this._allKeys.delete(key);
        }

        this.protected_needsUpdate(this._modifiedKeys.size !== 0);
    }
}

export default DictTracker;
